var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HeaderFooter",model:{value:(_vm.readcms),callback:function ($$v) {_vm.readcms=$$v},expression:"readcms"}},[(_vm.view_area === 'header')?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.headerFooter.field_header)}})]:(_vm.view_area === 'footer')?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.headerFooter.field_footer)}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }